export default __webpack_public_path__ + "static/media/Shan-logo-before.d7916970.png";